import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnRangeNumberPicker } from '@cainiaofe/cn-ui';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'RangeNumberPicker',
    component: CnRangeNumberPicker,
    formComponent: CnRangeNumberPicker,
};
